<template>
  <v-col class="pr-0 pr-sm-2" cols="12" sm="7" md="8">
    <DeliveryAddressStatusDialog
      :addressState="addressState"
      :close="closeDeliveryAddressStatusDialog"
      :visible="deliveryAddressStatusDialogVisible"
    />
    <ClosedForDeliveryDialog
      :close="closeClosedForDeliveryDialog"
      :visible="!!cart.closedForDeliveryMessage"
    />
    <NoAlcoholOrTobaccoDeliveryDialog
      :closeNoAlcoholOrTobaccoDeliveryDialog="
        closeNoAlcoholOrTobaccoDeliveryDialog
      "
      :interstateDeliveryIssue="$options.interstateDeliveryIssue"
      :noAlcoholOrTobaccoDeliveryDialog="noAlcoholOrTobaccoDeliveryDialog"
    />
    <ServiceNowDialog
      :closeServiceNowDialog="closeServiceNowDialog"
      :serviceNowDialog="serviceNowDialog"
    />
    <SelectTimeDialog
      :closeSelectTimeDialog="closeSelectTimeDialog"
      :hoursForSelectedDay="hoursForSelectedDay"
      :selectTimeDialog="selectTimeDialog"
      :upDateTime="upDateTime"
    />

    <div class="background-color-white full-height pa-5 pt-0 pt-sm-5">
      <v-form ref="form" :value="validNameAndPhone" class="full-width">
        <v-row justify="center">
          <v-col cols="6" md="5" xl="4">
            <div class="checkout-customize__label">Full Name</div>
            <v-text-field
              class="checkout-customize__input e2e-customer-fullname"
              :value="name"
              :rules="[requiredCheck]"
              @input="updateName"
              maxlength="200"
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="5" xl="4">
            <div class="checkout-customize__label">Phone</div>
            <v-text-field
              class="checkout-customize__input e2e-customer-phone"
              type="tel"
              :rules="[phoneCheck, requiredCheck]"
              :value="formattedPhoneNumber"
              @input="updatePhone"
              maxlength="14"
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify-md="center" v-if="order.service === 'DELIVERY'">
          <v-col cols="12" md="5" xl="4">
            <GoogleAutocomplete
              :addressState="addressState"
              :openDeliveryAddressStatusDialog="openDeliveryAddressStatusDialog"
              :requestSchedulingOptions="requestSchedulingOptions"
              :setFullAddress="setFullAddress"
              :setOrderAddress="setOrderAddress"
              :setVisibilityOfScheduleButtons="setVisibilityOfScheduleButtons"
            />
          </v-col>
          <v-col cols="6" md="5" xl="4">
            <div class="checkout-customize__label">Apt/Suite/Floor</div>
            <v-text-field
              class="checkout-customize__input"
              :value="order.address.address2"
              maxlength="150"
              placeholder="Optional"
              @input="(apt) => $store.commit('orders/SET_APARTMENT', apt)"
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <section class="checkout-page__lower-section">
        <v-row v-if="storeInfo.delivery_support" justify="center">
          <v-col md="8" lg="6">
            <h4 class="pickup-or-delivery-text text-center">
              Pickup or Delivery
            </h4>

            <div class="checkout-page__2-variant-buttons">
              <v-btn
                :color="order.service === 'PICKUP' ? 'primary' : ''"
                :height="styles.serviceButtons.height"
                :width="styles.serviceButtons.width"
                rounded
                @click.stop="handlePickupServiceSelection"
              >
                <div class="checkout-label-font-size text-capitalize">
                  pickup
                </div>
              </v-btn>

              <v-btn
                :color="order.service === 'DELIVERY' ? 'primary' : ''"
                :disabled="cart.awaitingDeliveryDataUpdate"
                :loading="cart.awaitingDeliveryDataUpdate"
                :height="styles.serviceButtons.height"
                :width="styles.serviceButtons.width"
                rounded
                @click.stop="requestSchedulingOptions"
              >
                <div class="checkout-label-font-size text-capitalize">
                  Delivery
                </div>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="storeInfo.delivery_name === 'Bringg'" align="center">
          <v-col class="d-flex checkout-label-font-size justify-center">
            <div
              v-if="
                cart.bringgDeliveryETA &&
                !cart.awaitingDeliveryDataUpdate &&
                this.order.service === $options.SERVICE.DELIVERY.type
              "
              class="d-flex eta justify-center px-2"
            >
              <span class="mr-2">Order ETA:</span>
              <span class="font-weight-semibold">{{
                cart.bringgDeliveryETA
              }}</span>
            </div>
          </v-col>
        </v-row>

        <v-row v-show="showScheduleButtons" justify="center" class="mt-md-3">
          <v-col md="8" lg="6">
            <div
              class="text-capitalize text-center mb-4"
              style="font-size: 22px"
            >
              schedule
              {{ scheduleButtonHeaderText() }}
            </div>

            <div class="checkout-page__2-variant-buttons">
              <v-btn
                :color="serviceNowButtonColor"
                :height="styles.serviceButtons.height"
                :width="styles.serviceButtons.width"
                :loading="serviceNowDataLoading"
                rounded
                @click.stop="requestServiceNow"
              >
                <div class="checkout-label-font-size text-capitalize">now</div>
              </v-btn>
              <v-btn
                :color="selectTimeButtonColor"
                :height="styles.serviceButtons.height"
                :width="styles.serviceButtons.width"
                rounded
                @click.stop="requestServiceTimes"
              >
                <div
                  class="checkout-label-font-size text-capitalize e2e-button-selecttime"
                >
                  <span
                    v-if="
                      order.selectedDate.iso &&
                      order.selectedTime.time &&
                      !order.serviceNow
                    "
                  >
                    {{ order.selectedDate.display }}
                    <br />
                    {{ order.selectedTime.display }}
                  </span>
                  <span v-else data-selecteddate="false">select time</span>
                </div>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col lg="9" xl="6">
            <div class="font-size-lg-res mb-3 text-center e2e-ordercomments">
              Your Order Comments
              {{
                order.service === $options.SERVICE.DELIVERY.type
                  ? "and Delivery Notes"
                  : ""
              }}
            </div>
            <v-textarea
              label="Place comments and delivery instructions here!"
              class="checkout-customize__comments"
              data-ordercustomize="comments"
              :value="order.comment"
              @input="
                (val) =>
                  $store.commit('orders/UPDATE', { name: 'comment', val })
              "
              maxlength="500"
              rows="3"
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>

        <OrderSubstitutions />

        <OrderTips
          v-if="
            order.service === 'DELIVERY' &&
            storeInfo.delivery_name === 'Bringg' &&
            !cart.awaitingDeliveryDataUpdate
          "
          :selectedTip="selectedTip"
          :setSelectedTip="setSelectedTip"
          :setTipAmountOnChange="setTipAmountOnChange"
          :tipText="tipText"
        />
      </section>
    </div>
  </v-col>
</template>

<script>
import { AddressState } from "@/types/address.js";
import { mapGetters, mapState } from "vuex";
import { formatCurrency, formatPhoneNumber } from "@/util.js";
import { styles } from "@/components/Order/Customize/styles";
import DeliveryAddressStatusDialog from "@/components/Cart/Dialogs/DeliveryAddressStatus.vue";
import ClosedForDeliveryDialog from "@/components/Cart/Dialogs/ClosedForDeliveryDialog.vue";
import GoogleAutocomplete from "@/components/Google/Autocomplete.vue";
import NoAlcoholOrTobaccoDeliveryDialog from "@/components/Order/Dialogs/NoAlcoholOrTobaccoDelivery.vue";
import SelectTimeDialog from "@/components/Order/Dialogs/SelectTime.vue";
import ServiceNowDialog from "@/components/Order/Dialogs/ServiceNow.vue";
import OrderSubstitutions from "@/components/Order/Customize/OrderSubstitutions.vue";
import OrderTips from "@/components/Order/Customize/OrderTips.vue";
import { storeHoursRemaining, nowIsAfterStoreStartMoment } from "@/helper";
import { Tips } from "@/types/tips";

const interstateDeliveryIssue = false;

const SERVICE = Object.freeze({
  DELIVERY: {
    text: "delivery",
    type: "DELIVERY",
  },
  PICKUP: {
    text: "pickup",
    type: "PICKUP",
  },
});

export default {
  name: "CustomizeOrder",
  components: {
    OrderTips,
    OrderSubstitutions,
    DeliveryAddressStatusDialog,
    ClosedForDeliveryDialog,
    GoogleAutocomplete,
    NoAlcoholOrTobaccoDeliveryDialog,
    SelectTimeDialog,
    ServiceNowDialog,
  },
  computed: {
    ...mapGetters("cart", {
      containsAlcohol: "containsAlcohol",
      containsAlcoholOrTobacco: "containsAlcoholOrTobacco",
      containsTobacco: "containsTobacco",
    }),
    ...mapState({
      cart: (state) => state.cart,
      order: (state) => state.orders.order,
      storeInfo: (state) => state.store.info,
      user: (state) => state.user.info,
    }),
    formattedPhoneNumber() {
      return (this.order && this.order.phone) || this.order.phone !== null
        ? this.order.phone
        : this.user && this.user.phone
        ? formatPhoneNumber(this.user.phone)
        : null;
    },
    name() {
      return (this.order && this.order.customerName) ||
        this.order.customerName !== null
        ? this.order.customerName
        : this.user && this.user.name
        ? this.user.name
        : null;
    },
    selectTimeButtonColor() {
      return this.order.selectedTime &&
        this.order.selectedDate.iso &&
        this.order.selectedTime.time &&
        !this.order.serviceNow
        ? "primary"
        : "";
    },
    serviceNowButtonColor() {
      return this.order.serviceNow ? "primary" : "";
    },
    styles() {
      return this.$vuetify.breakpoint.xsOnly ? styles.xs : styles.smAndUp;
    },
  },
  data() {
    return {
      deliveryAddressStatusDialogVisible: false,
      hoursForSelectedDay: null,
      noAlcoholOrTobaccoDeliveryDialog: false,
      selectTimeDialog: false,
      serviceNowDialog: false,
      serviceNowDataLoading: false,
      showScheduleButtons: false,
    };
  },
  interstateDeliveryIssue,
  methods: {
    async checkDeliveryMethod() {
      await this.$store.dispatch("cart/fetchDeliveryData");
      if (this.cart.deliveryDataUpdated) {
        this.handleDeliveryServiceSelection();

        const bringgDelivery = this.storeInfo.delivery_name === "Bringg";
        bringgDelivery
          ? this.setVisibilityOfScheduleButtons(false)
          : this.setVisibilityOfScheduleButtons(true);
      }
    },
    scheduleButtonHeaderText() {
      return this.order.service === this.$options.SERVICE.DELIVERY.type
        ? this.$options.SERVICE.DELIVERY.text
        : this.$options.SERVICE.PICKUP.text;
    },
    checkNameAndPhoneValidity() {
      const valid = this.$refs.form.validate();
      this.setNameAndPhoneValidity(valid);
    },
    closeDeliveryAddressStatusDialog() {
      this.deliveryAddressStatusDialogVisible = false;
    },
    closeClosedForDeliveryDialog() {
      this.cart.closedForDeliveryMessage = "";
    },
    closeNoAlcoholOrTobaccoDeliveryDialog() {
      this.noAlcoholOrTobaccoDeliveryDialog = false;
    },
    closeSelectTimeDialog() {
      this.selectTimeDialog = false;
    },
    closeServiceNowDialog() {
      this.serviceNowDialog = !this.serviceNowDialog;
    },
    doesStoreDeliverAlcoholAndTobaccoProducts() {
      const storeDeliversAlcohol = this.storeInfo.alcohol_delivery_allowed;
      const storeDeliversTobacco = this.storeInfo.tobacco_delivery_allowed;

      const issueWithAlcohol = !storeDeliversAlcohol && this.containsAlcohol;
      const issueWithTobacco = !storeDeliversTobacco && this.containsTobacco;

      const issueWithStateDeliveryOfAlcoholOrTobacco =
        issueWithAlcohol || issueWithTobacco;

      issueWithStateDeliveryOfAlcoholOrTobacco
        ? this.openNoAlcoholOrTobaccoDeliveryDialog(false)
        : this.checkDeliveryMethod();
    },
    formatCurrency,
    async handleDeliveryServiceSelection() {
      this.$store.commit("orders/UPDATE_SERVICE_TYPE", "DELIVERY");

      const bringgDelivery = this.storeInfo.delivery_name === "Bringg";

      // Check if store is open and available for delivery. If it is, this function will continue
      // If the store is Bringg, serviceNow will be set as true. Otherwise, it will be false until user clicks now.
      // This way users will see the popup that shows the ETA
      const deliveryServiceNow = bringgDelivery;
      await this.isServiceAvailableNow(deliveryServiceNow);

      if (bringgDelivery) {
        this.$store.commit("orders/UPDATE_SELECTED_DATE_AND_TIME", {
          timeZone: this.storeInfo.tz,
          waitTime: this.storeInfo.waitTime,
        });
        await this.$store.dispatch("orders/setReadyToPay", true);
      }

      /*
         1. if alcohol or tobacco in cart and not permitted show "to proceed with your delivery order, please remove these items"
         2. if address empty show "please enter your delivery address first"
         3. if address is not a Google suggested address show "please pick from suggested addresses"
         4. if address out of delivery area show "your address is outside of the delivery area" 5. if address invalid show "your address is outside of the delivery area"
         6. if address garbage show "your address is outside of the delivery area"
         7. if valid, then add storeInfo.waitTime to deliveryDuration and that's the delivery estimate
      */
      /*
         conditions in which we close the schedule buttons:
         the google address is not valid
         this.order.address.full_address !== this.order.lastFormattedAddress;
      */
    },

    handlePickupServiceSelection() {
      // Reset driver tip if choosing pickup
      this.setSelectedTip({ cents: 0 });
      // This always returns false. I don't know why it's here, and it's being removed for now
      // if (this.order.service === this.$options.SERVICE.PICKUP.type) return;
      !this.showScheduleButtons && this.setVisibilityOfScheduleButtons(true);

      this.$store.commit("orders/UPDATE_SERVICE_TYPE", "PICKUP");
      this.resetServiceState();
    },
    isBringgAlcoholAndTobaccoDeliveryAllowed() {
      const bringgDeliversAlcohol =
        this.storeInfo.bringg_alcohol_delivery_allowed;
      const bringgDeliversTobacco =
        this.storeInfo.bringg_tobacco_delivery_allowed;

      const issueWithAlcohol = !bringgDeliversAlcohol && this.containsAlcohol;
      const issueWithTobacco = !bringgDeliversTobacco && this.containsTobacco;

      const issueWithBringgDeliveryOfAlcoholOrTobacco =
        issueWithAlcohol || issueWithTobacco;

      const bringgDelivery = this.storeInfo.delivery_name === "Bringg";
      bringgDelivery && issueWithBringgDeliveryOfAlcoholOrTobacco
        ? this.openNoAlcoholOrTobaccoDeliveryDialog(false)
        : this.checkDeliveryMethod();
    },
    isInterstateDelivery() {
      const bringgDelivery = this.storeInfo.delivery_name === "Bringg";
      const deliveryAddress = this.order.address.state;
      const storeState = this.storeInfo.state;
      const interstateDeliveryIssue = deliveryAddress !== storeState;

      interstateDeliveryIssue
        ? this.openNoAlcoholOrTobaccoDeliveryDialog(true)
        : bringgDelivery
        ? this.isBringgAlcoholAndTobaccoDeliveryAllowed()
        : this.doesStoreDeliverAlcoholAndTobaccoProducts();
    },
    async isServiceAvailableNow(deliveryServiceNow) {
      // run store update mutation to refresh service days (pickup or delivery) for this moment
      await this.$store.dispatch("store/fetchAndModifyService", {
        serviceNow: deliveryServiceNow,
      });

      this.$store.commit("orders/UPDATE", {
        name: "serviceNow",
        val: deliveryServiceNow,
      });

      const bringgDelivery = this.storeInfo.delivery_name === "Bringg";
      if (bringgDelivery) {
        this.setSelectedTip(Tips.twenty);
      }

      return (
        storeHoursRemaining(this.storeInfo) &&
        nowIsAfterStoreStartMoment(this.storeInfo)
      );
    },
    openNoAlcoholOrTobaccoDeliveryDialog(interstateDeliveryIssue) {
      this.$options.interstateDeliveryIssue = interstateDeliveryIssue;
      this.noAlcoholOrTobaccoDeliveryDialog = true;
    },
    openDeliveryAddressStatusDialog() {
      this.showScheduleButtons = false;
      this.deliveryAddressStatusDialogVisible = true;
    },
    openSelectTimeDialog() {
      // run store update mutation to refresh service for this moment
      this.$store.commit("orders/UPDATE", {
        name: "serviceNow",
        val: false,
      });

      this.$store.dispatch("store/fetchAndModifyService", {
        serviceNow: false,
      });

      this.selectTimeDialog = !this.selectTimeDialog;
    },
    async openServiceNowDialog() {
      let availableNow = await this.isServiceAvailableNow(true);
      this.$store.commit("orders/UPDATE", {
        name: "serviceNow",
        val: availableNow,
      });
      this.serviceNowDialog = true;
      this.serviceNowDataLoading = false;
    },
    phoneCheck(value) {
      const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return pattern.test(value) || "Invalid phone number.";
    },
    async requestSchedulingOptions() {
      this.showScheduleButtons = false;
      this.$store.commit("orders/UPDATE_SERVICE_TYPE", "DELIVERY");
      if (this.addressState !== AddressState.valid)
        return this.openDeliveryAddressStatusDialog();
      this.validateAlcoholAndTobaccoDelivery();
    },
    async requestServiceNow() {
      if (this.order.service === "DELIVERY") {
        await this.$store.dispatch("cart/fetchDeliveryData");
      } else {
        await this.$store.dispatch("cart/fetchPickupData");
      }
      await this.openServiceNowDialog();
    },
    async requestServiceTimes() {
      if (this.order.service === "DELIVERY") {
        await this.$store.dispatch("cart/fetchDeliveryData");
      } else {
        await this.$store.dispatch("cart/fetchPickupData");
      }
      this.resetServiceState();
      this.openSelectTimeDialog();
    },
    requiredCheck(value) {
      return !!value || "Required.";
    },
    resetServiceState() {
      this.hoursForSelectedDay = null;
      const bringgDelivery = this.storeInfo.delivery_name === "Bringg";
      if (bringgDelivery) {
        this.$store.commit("cart/CLEAR_BRINGG_DELIVERY_ETA");
      }
      this.$store.commit("orders/UPDATE", { name: "selectedDate", val: {} });
      this.$store.commit("orders/UPDATE", { name: "selectedTime", val: {} });
      this.$store.commit("orders/UPDATE", { name: "serviceNow", val: false });
    },
    setVisibilityOfScheduleButtons(bool) {
      this.showScheduleButtons = bool;
    },
    updateName(val) {
      const valid = this.$refs.form.validate();
      this.setNameAndPhoneValidity(valid);
      this.$store.commit("orders/UPDATE", { name: "customerName", val });
    },
    upDateTime(name, val) {
      if (!val) {
        /*
        change event fires this callback function but if date or time the same,
        no value passed to this function

        */
        return;
      }
      this[name] = val;
      if (name === "selectedDate") {
        this.$store.commit("orders/UPDATE", { name: "selectedTime", val: {} });
        this.$store.commit("orders/UPDATE", {
          name: "selectedDate",
          val,
        });
      } else {
        this.$store.commit("orders/UPDATE", {
          name: "selectedTime",
          val,
        });
      }
    },
    updatePhone(val) {
      this.checkNameAndPhoneValidity();
      this.$store.commit("orders/UPDATE_PHONE", val);
    },
    validateAlcoholAndTobaccoDelivery() {
      // this.$store.dispatch("cart/fetchDeliveryData");
      // this.resetServiceState();
      return !this.containsAlcoholOrTobacco
        ? this.checkDeliveryMethod()
        : this.isInterstateDelivery();
    },
  },
  mounted() {
    this.$store.commit("cart/CLEAR_BRINGG_DELIVERY_ETA");
    this.checkNameAndPhoneValidity();
    // want to show immediately if pickup only service
    const bringgDelivery = !!this.storeInfo.delivery_name === "Bringg";
    this.setVisibilityOfScheduleButtons(
      !this.storeInfo.delivery_support || bringgDelivery,
    );
  },
  SERVICE,
  props: {
    addressState: String,
    selectedTip: Object,
    setFullAddress: Function,
    setNameAndPhoneValidity: Function,
    setOrderAddress: Function,
    setSelectedTip: Function,
    setTipAmountOnChange: Function,
    tipText: String,
    validNameAndPhone: Boolean,
  },
  watch: {
    "order.selectedDate": function (val) {
      if (!val) return;
      if (!val.iso) return;
      this.hoursForSelectedDay = this.storeInfo.serviceDays.find(
        (day) => day.iso === val.iso,
      ).times;
    },
  },
};
</script>

<style lang="scss">
.checkout-customize {
  &__label {
    font-size: 12px;
  }

  &__input {
    font-size: 10.4px;
  }

  &__comments {
    & label {
      font-size: 12px;
    }
  }
}

.checkout-page {
  &__2-variant-buttons {
    display: flex;
    justify-content: space-evenly;
  }
}

.pickup-or-delivery-text {
  margin: 40px 0 24px 0;
  font-size: 16px;
  font-weight: normal;
}

.eta {
  /* animation: createBox 0.25s; */
  /* background-color: #f5f5f5; */
  /* border: solid #2a2825 1px; */
  animation-name: scaleIn;
  animation-duration: 2s;
  height: 40px;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .pickup-or-delivery-text {
    font-size: 22px;
  }
  .checkout-page {
    &__lower-section {
      max-width: 936px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }
  }
  .checkout-customize {
    &__label {
      font-size: 20px;
    }

    &__input {
      font-size: 16px;
    }

    &__comments {
      & label {
        font-size: 16px;
      }
    }
  }
}

@keyframes scaleIn {
  0% {
    transform: scale(0.2);
  }
  85% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
